
import { defineComponent } from 'vue';
import Modal from '@/components/ui-components/Modal.vue';
import ModalCard from '@/components/ui-components/ModalCard.vue';
import ButtonBlue from '@/components/ui-components/ButtonBlue.vue';
import ButtonWhite from '@/components/ui-components/ButtonWhite.vue';

const __default__ = defineComponent({
    name: 'PreavisConfirmationCreatedModal',
    components: { Modal, ModalCard, ButtonBlue, ButtonWhite },
    props: {
        visible: { type: Boolean, required: true },
        hideNouveauPreavis: { type: Boolean, default: false },
        width: { type: String, default: '45vw' },
        maxWidth: { type: String, default: '50%' },
        height: { type: String, default: '10vw' },
    },
    emits: ['close', 'mes-preavis', 'nouveau-preavis'],
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "v4f5d61fd": (_ctx.height)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__